
import NotificationCircle from "../../../assets/outline/NotificationCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NotificationCircleIcon({ className, dataTestid = "NotificationCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NotificationCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
